<template>
    <div :class="containerClass">
        <b-form-radio
            v-for="choice in orderChoices"
            :name="name"
            :value="choice"
            v-model="order"
            :disabled="disabled"
            class="mt-0"
            @input="onOrderChange"
        >
            {{ $t('Component(ConcernElementPlacementHierarchyOrderEnum):' + choice) }}
        </b-form-radio>
    </div>
</template>

<script>
import {ConcernElementPlacementOrder} from "@core/domain/product";
import {BFormRadio} from 'bootstrap-vue'

export default {
    components: {BFormRadio},
    props: {
        disabled: {
            default: false
        },
        defaultValue: {
            default() {
                return ConcernElementPlacementOrder.TOP_DOWN;
            }
        },
        name: {
            type: String,
        },
        containerClass: {
            default: 'demo-inline-spacing'
        }
    },
    data() {
        return {
            order: this.defaultValue,
            orderChoices: ConcernElementPlacementOrder.toArray(),
        };
    },
    methods: {
        onOrderChange() {
            this.$emit('input', this.order);
        }
    }
}
</script>
